export default __webpack_public_path__ + "static/dark_grey-19df4a944c86735fc188972132911bc5.webp";